import { render, staticRenderFns } from "./page_home.vue?vue&type=template&id=3c42d3a6&scoped=true"
import script from "./page_home.vue?vue&type=script&lang=js"
export * from "./page_home.vue?vue&type=script&lang=js"
import style0 from "./page_home.vue?vue&type=style&index=0&id=3c42d3a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c42d3a6",
  null
  
)

export default component.exports